var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,attrs:{"id":_vm.id,"tabindex":"-1"}},[(_vm.visible)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }